//
// Voucher.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "@sas-dvr/ltjs-commons/util/BaseVoucher";
import "../models/TransportModel";
import "./warnings/TransportWarning";

var Voucher = createModule("transport::Voucher", ["commons::BaseVoucher"], EventDispatcher, [
    {
        FULFILLED: 10006,
        ISSUED: 10004,
        CANCELLED: 10005,
        WARNING: 10007,
    },
    ,
    ,
    ,
    {
        getRequestedResource: [1],
        getWarning: [1],
    },
    {
        _create: [4],
    },
    ,
]);
export default Voucher;
